import script from "./EventsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__